import { useTranslation } from "react-i18next";
import { formatNumber } from "utils/utils";
import { formatHours } from "../logic/tips.format.logic";
import type { MonthlyReportTotals } from "./tips.monthlyReports.logic";
import { MonthlyTotalRow } from "./tips.monthlyReports.styled";

interface MonthlyReportTotalsRowProps {
  readonly hourLabel: string;
  readonly minuteLabel: string;
  readonly totals: MonthlyReportTotals;
}

export const MonthlyReportTotalsRow = (
  props: MonthlyReportTotalsRowProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <MonthlyTotalRow>
      <div>{t("MonthlyTipReport.Total")}</div>
      <div>
        {formatNumber(props.totals.totalTipsAmount)} {t("Tips.Currency")}
      </div>
      <div>
        {formatHours({
          hourLabel: props.hourLabel,
          hours: props.totals.totalHours,
          minuteLabel: props.minuteLabel,
        })}{" "}
        {t("MonthlyTipReport.HoursLowercase")}
      </div>
      <div>
        {formatNumber(props.totals.distributedAmount)} {t("Tips.Currency")}
      </div>
      <div>
        {formatNumber(props.totals.paidOutAmount)} {t("Tips.Currency")}
      </div>
      <div />
    </MonthlyTotalRow>
  );
};
